import { addDays } from 'date-fns';

import type { DateRangePickerProps } from '@semcore/ui/date-picker';

import type { FilterState } from '@/shared/lib/filter/model/types';
import { getServerDate } from '@/shared/lib/utils/getServerDate';
import DateRange from '@/shared/ui/date-range';
import { dateToYMD, YMDToDate } from '@/shared/ui/date-range/ui/DateRange';

export interface IPageFilterProps
  extends DateRangePickerProps,
  Required<Pick<FilterState, 'dateFrom' | 'dateTo'>> {
  onFromChange: (date: FilterState['dateFrom']) => void;
  onToChange: (date: FilterState['dateTo']) => void;
  controlDisabled?: boolean;
}

export default function Picker({
  dateFrom,
  dateTo,
  onFromChange,
  onToChange,
  controlDisabled,
  ...other
}: IPageFilterProps) {
  const today = getServerDate();
  const tomorrow = addDays(today, 1);

  return (
    <DateRange
      value={dateFrom && dateTo ? [YMDToDate(dateFrom), YMDToDate(dateTo)] : undefined}
      onChange={([start, end]) => {
        if (!start || !end) return;

        onFromChange(dateToYMD(start));
        onToChange(dateToYMD(end));
      }}
      disabled={[[YMDToDate(dateToYMD(tomorrow)), false]]}
      controlDisabled={controlDisabled}
      {...other}
    />
  );
}
